import { Component, Input, OnInit, EventEmitter, Output } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { SpinnerService } from 'shared-components';
import { CultivosService } from "../../../../../services/cultivos.service";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { Subject } from "rxjs";

@Component({
    selector: 'app-cultivo-productor-new-edit',
    templateUrl: './new-edit.component.html'
})
export class CPNewEditComponent implements OnInit {
    private _cultivoProductor;
    public newEditForm;
    private _filters;
    public showError: boolean;
    public disable = false;
    public licencias = false;
    public nLicencias = "";

    public _toDelete: any;
    public _editable: boolean;
    public _productoresList: any;

    public _cultivoId;
    public _productorId;
    public productor;
    public licenciasList = [];

    public deleteModal = false;
    public licenciasModal = false;

    public disabled: Subject<boolean> = new Subject();

    @Input() cultivoProductor?;
    @Input() cultivoId;
    @Input() paisId;
    @Input() denominacionId;
    @Input() productoresList;
    @Input() campanyaHabilitada;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() pushMessage = new EventEmitter<string>();
    @Output() editableChanged = new EventEmitter<any>();
    @Output() close = new EventEmitter<boolean>();

    get editable(): boolean { return this._editable; }
    @Input() set editable(value: boolean) {
        this._editable = value;
        if (this.newEditForm) {
            if (value) {
                this.newEditForm.get('productor').enable();
                this.disabled.next(false);
            } else {
                this.newEditForm.disable();
                this.disabled.next(true);
            }
        }
    }

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _dataProvider: DataProvider,
        private readonly _cultivosService: CultivosService,
        private readonly _sessionContext: SessionContextService

    ) {}

    ngOnInit() {
        this._spinnerService.showSpinner();
        this.newEditForm = this._fb.group({
            productor: ['', Validators.required],
        });

        if (this.editable) {
            this.newEditForm.get('productor').enable();
            this.disabled.next(false);
        } else {

            this.getProductores();
            this.newEditForm.disable();
            this.disabled.next(true);
        }
        this._spinnerService.hideSpinner();
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public getProductores() {
        this.nLicencias = '';
        if(this.cultivoProductor) {
            this.disabled.next(true);
            this.productor = this.productoresList.find(x => x.id === this.cultivoProductor.productorId);
            this.newEditForm.patchValue({
                productor: this.productor,
            });
            if (this.cultivoProductor.cultivosProductorLicencia.length > 0) {
                this.cultivoProductor.cultivosProductorLicencia.forEach(cultivoProductorLicencia => {
                    this.nLicencias += cultivoProductorLicencia.nLicencia + ", "
                });

                this.nLicencias = this.nLicencias.slice(0, this.nLicencias.length - 2);

                this.licencias = true;
            } else {
                this.licencias = false;
            }
        }
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid && !this.cultivoProductor) {
            this._cultivoProductor = {
                cultivoId: this.cultivoId,
                productorId: this.newEditForm.get('productor').value.id,
                lsNLicencia: null
            };
            this._spinnerService.showSpinner();
            this._cultivosService.createCultivoProductor(this._cultivoProductor).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                if (resp) {
                    this._editable = false;
                    this.refresh.emit(true);
                    this.disabled.next(true);
                    this.newEditForm.disable();
                    this.pushMessage.emit('global.success.itemCreated');
                } else {
                    this.showError = true;
                    this.pushMessage.emit('global.error.noResponse');
                }
            });
        }
    }

    public cancel() {
        if (this.cultivoProductor != null) {
            this.close.emit(true);
            this.refresh.emit(true);
        } else {
            this.editableChanged.emit();
        }
    }

    public closeModal() {
        this.deleteModal = false;
        this.licenciasModal = false;
        this._toDelete = '';
    }

    public edit(cultivoProductor) {
        this.newEditForm.get('productor').enable();
        this.newEditForm.get('licencia').enable();
        this.disabled.next(true);
        this.editableChanged.emit(cultivoProductor);
    }

    public askDelete(cultivoProductor) {
        this._cultivoId = cultivoProductor.cultivoId;
        this._productorId = cultivoProductor.productorId;
        this.deleteModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._cultivosService.deleteCultivoProductor(this._cultivoId, this._productorId).toPromise().finally(() => {
        }).then(() => {
          this.closeModal();
          this.refresh.emit(true);
          this.pushMessage.emit('global.success.itemDeleted');
        });
    }

    public openLicencias(cultivoProductor) {
        this._cultivoId = cultivoProductor.cultivoId;
        this._productorId = cultivoProductor.productorId;
        this.licenciasModal = true;
    }

    public toRefresh(value) {
        this._spinnerService.showSpinner();
        this.nLicencias = "";
        this._cultivosService.getCultivoProductor(this._cultivoId, this._productorId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            if (resp.cultivosProductorLicencia.length > 0) {
                resp.cultivosProductorLicencia.forEach(cultivoProductorLicencia => {
                    this.nLicencias += cultivoProductorLicencia.nLicencia + ", "
                });

                this.nLicencias = this.nLicencias.slice(0, this.nLicencias.length - 2);
                this.licencias = true;
            } else {
                this.licencias = false;
            }
        });
        this.licenciasModal = false;
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.pushMessage.emit('global.error.required');
        }
    }
}
